import NProgress from 'nprogress';

// checks if entity has children or not
export const checkDeleteValidity = (entity) => {
    if (entity?.children?.length > 0) {
        return true;
    }
    return false;
};

export const executeLoader = (flag) => {
    if (flag) {
        NProgress.start();
    } else {
        NProgress.done();
    }
};


// Feature key → backend preference code mapping
const featurePreferenceMap = {
    'assurance-level': 'assurance_level_enabled',
};

// Per-company preferences cache, keyed by company ID
const companyPreferencesCache = {};

export function setCompanyPreferences(companyId, preferences) {
    companyPreferencesCache[companyId] = preferences;
}

export function hasCompanyFeature(companyId, featureKey) {
    const preferenceCode = featurePreferenceMap[featureKey];
    if (!preferenceCode) return false;

    const prefs = companyPreferencesCache[companyId];
    if (!prefs) return false;

    return prefs[preferenceCode] == 1;
}
